<label *ngIf="label">{{ label }}</label>
<input
  [formControl]="control"
  type="text"
  [class]="'form-control input'"
  [readonly]="readonly"
  [placeholder]="placeholder == undefined ? '' : placeholder"
  autocomplete="new-input"
  [ngbTypeahead]="legalNameSearch"
  [inputFormatter]="searchInputFormatter"
  [editable]="true"
  [resultTemplate]="rt"
/>
<ng-template #rt let-r="result" let-t="term">
  <div class="d-flex">
    <!-- <div class="star" [class.match]="r.match"></div> -->
    <ngb-highlight [result]="r.value" [term]="t"></ngb-highlight>
  </div>
</ng-template>
